import { ForEachWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ForEach')
export class ForEachNodeConnectorProvider extends ConnectorProvider<ForEachWorkflowNode> {}
